import { Component, inject, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-team-join-dialog',
  templateUrl: './team-join-dialog.component.html',
  styleUrls: ['./team-join-dialog.component.scss'],
  standalone: false // same as ConfirmEmailComponent
})
export class TeamJoinDialogComponent {
  @Input() isOwner: boolean = false;
  @Input() isUserTeamPlayer: boolean = false;
  @Input() canFollow: boolean = false;
  private modalController = inject(ModalController);


  onSelect(role: string) {
    this.modalController.dismiss(null, role); // role goes in 2nd argument
  }

  dismiss() {
    this.modalController.dismiss();
  }
}
